import { Controller } from '@hotwired/stimulus'
import { clearAllDrafts } from '../utils/conversationDrafts'

export default class extends Controller {
  clear() {
    clearAllDrafts()
  }
}
